export function loadCookieYes(siteKey: string) {
  const script = document.createElement('script');
  script.id = 'cookieyes';
  script.type = 'text/javascript';
  script.src = `https://cdn-cookieyes.com/client_data/${siteKey}/script.js`;
  script.async = true;
  document.head.appendChild(script);
}